import {Injectable} from '@angular/core';
import {TradingPartner} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class TradingPartnerService extends TableOptionsService<TradingPartner> {
    constructor() {
        super();
    }

    public override matches(element: TradingPartner, term: string) {
        return (
            element.name?.toLowerCase().includes(term.toLowerCase())
            || (element.groupName ?? "").toLowerCase().includes(term.toLowerCase())
        );
    }
}
